var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#01ACFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 32.75C33.84 32.75 33.69 32.7 33.55 32.6C33.22 32.35 33.15 31.88 33.4 31.55C34.97 29.46 34.97 26.54 33.4 24.45C33.15 24.12 33.22 23.65 33.55 23.4C33.88 23.15 34.35 23.22 34.6 23.55C36.56 26.17 36.56 29.83 34.6 32.45C34.45 32.65 34.23 32.75 34 32.75Z",
    fill: "#01ACFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8301 35.25C35.6701 35.25 35.5201 35.2 35.3801 35.1C35.0501 34.85 34.9801 34.38 35.2301 34.05C37.9001 30.49 37.9001 25.51 35.2301 21.95C34.9801 21.62 35.0501 21.15 35.3801 20.9C35.7101 20.65 36.1801 20.72 36.4301 21.05C39.5001 25.14 39.5001 30.86 36.4301 34.95C36.2901 35.15 36.0601 35.25 35.8301 35.25Z",
    fill: "#01ACFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.02 19.78C28.9 19.16 27.47 19.32 26.01 20.23L23.09 22.06C22.89 22.18 22.66 22.25 22.43 22.25H21.5H21C18.58 22.25 17.25 23.58 17.25 26V30C17.25 32.42 18.58 33.75 21 33.75H21.5H22.43C22.66 33.75 22.89 33.82 23.09 33.94L26.01 35.77C26.89 36.32 27.75 36.59 28.55 36.59C29.07 36.59 29.57 36.47 30.02 36.22C31.13 35.6 31.75 34.31 31.75 32.59V23.41C31.75 21.69 31.13 20.4 30.02 19.78Z",
    fill: "#01ACFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.672ae96e47340ae7e9f672e8f327208c.svg";
export { ForwardRef as ReactComponent };